import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Sports(props: StickerArtProps) {
  return (
    <StickerFrame background="#16a34a" {...props}>
      <circle cx="32" cy="32" r="16" fill="#ffffff" stroke="#1f2937" strokeWidth="2" />
      <path d="M32 25 L38.7 29.8 L36.1 37.7 L27.9 37.7 L25.3 29.8 Z" fill="#1f2937" />
      <path
        d="M32 25 V16.5 M38.7 29.8 L47 26.5 M36.1 37.7 L41.5 45 M27.9 37.7 L22.5 45 M25.3 29.8 L17 26.5"
        stroke="#1f2937"
        strokeWidth="2.5"
      />
    </StickerFrame>
  );
}
